import countriesData from "@crm/src/pages/enquiry-form/country-state-data.json";
import { CITY_LABEL } from "@moxie/constants";
import { FormInstance, Input } from 'antd';
import Card from 'antd/es/card';
import Form from 'antd/es/form';
import { Col } from 'antd/es/grid';
import Select from "antd/es/select";
import Typography from 'antd/es/typography';
import { Row } from 'antd/lib/grid';
import React, { useEffect, useMemo, useState } from 'react';

interface AddressInfoCardProps {
  editMode: boolean;
  form: FormInstance;
}

interface ICountryStateData {
  [country: string]: string[];
}

const countriesStateData: ICountryStateData = countriesData;

const EnquiryViewAddressInfo = ({ editMode, form }: AddressInfoCardProps) => {
  const [selectedCountry, setSelectedCountry] = useState<string | undefined>(undefined);

  const filteredStateList = useMemo(() => {
    return selectedCountry ? countriesStateData[selectedCountry].sort() : [];
  }, [selectedCountry]);

  const handleCountryChange = (value: string) => {
    setSelectedCountry(value);
    form.setFieldsValue({
      addressInformation: {
        'state': undefined,
        'city': undefined,
      },
    })
  }

  const countriesList = Object.keys(countriesStateData).sort();

  useEffect(() => {
    const initialCountryVal = form.getFieldValue(["addressInformation", "country"]);
    if (initialCountryVal) {
      setSelectedCountry(initialCountryVal);
    }
  }, [editMode])

  return (
    <Card className="margin-top-2" title={<Typography.Text strong>Address Information</Typography.Text>} headStyle={{ background: "none" }}>
      <Row>
        <Col span={11}>
          <Form.Item
            label="Country"
            name={["addressInformation", "country"]}
            validateFirst={true}
            rules={[
              {
                required: true,
                message: 'Please select country',
              },
            ]}
          >
            <Select
              placeholder="Please select country"
              showSearch
              optionFilterProp="searchprop"
              onChange={handleCountryChange}
              disabled={!editMode}
            >
              {countriesList.map((country, index) => (
                <Select.Option value={country} key={index} searchprop={country}>
                  {country}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={11} offset={2}>
          <Form.Item
            name={['addressInformation', 'state']}
            label="State"
            validateFirst={true}
            rules={[
              {
                required: true,
                message: 'Please select state',
              },
            ]}
          >
            <Select
              optionFilterProp="searchprop"
              allowClear={false}
              disabled={!editMode}>
              {filteredStateList.map((state: string) => {
                return (
                  <Select.Option value={state} key={state} searchprop={state}>
                    {state}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        name={["addressInformation", "city"]}
        label={CITY_LABEL}
        validateFirst={true}
        rules={[
          {
            required: true,
            message: 'Please enter city',
          },
        ]}
      >
        <Input className={!editMode ? 'enquiry-view-form__cursor-default' : ''} placeholder="Please enter city" readOnly={!editMode} />
      </Form.Item>
    </Card >
  )
}

export { EnquiryViewAddressInfo };
